import { render } from "./SelectedProduct.vue?vue&type=template&id=1b60ec21"
import script from "./SelectedProduct.vue?vue&type=script&lang=js"
export * from "./SelectedProduct.vue?vue&type=script&lang=js"

import "./SelectedProduct.vue?vue&type=style&index=0&id=1b60ec21&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__